import { Box, Image, Link, Stack } from '@chakra-ui/core'
import React from 'react'
import { BAOTREE_CONTACT_PAGE_URL, BAOTREE_WEBSITE_URL } from '../../constants'
import { images } from '../../theme'
const links = [
  {
    href: BAOTREE_WEBSITE_URL,
    label: 'baotree.io'
  },
  {
    href: BAOTREE_CONTACT_PAGE_URL,
    label: 'Contact Us'
  }
]

const Nav = () => {
  return (
    <Box position="absolute" top={0} left={0} px={2} py={4} zIndex={100} w="100%">
      <Stack direction="row" alignItems="center" spacing={2}>
        <Link href="/">
          <Image src={images.logo} height="3rem" />
        </Link>
        <Stack spacing={3} direction="row" alignItems="center">
          {links.map((link, index) => (
            <Link
              key={index}
              href={link.href}
              isExternal
              fontSize="x-small"
              fontWeight="extrabold"
              textTransform="uppercase"
            >
              {link.label}
            </Link>
          ))}
        </Stack>
      </Stack>
    </Box>
  )
}

export default Nav
